'use client';
import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './styles.css';

interface Partner {
    id: number;
    name: string;
}

const CompanyStats: React.FC = () => {
    const partnerSliderSettings = {
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        arrows: false,
        pauseOnHover: true,
        cssEase: "linear",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };

    const partners: Partner[] = [
        { id: 1, name: "Partner 1" },
        { id: 2, name: "Partner 2" },
        { id: 3, name: "Partner 3" },
        { id: 1, name: "Partner 1" }, // Duplicate to ensure continuous loop
        { id: 2, name: "Partner 2" },
        { id: 3, name: "Partner 3" },
    ];

    return (
        <section className="py-20 bg-white">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    <div className="relative h-[500px] rounded-2xl overflow-hidden">
                        <img
                            src="/images/vision.jpg"
                            alt="Company Vision"
                            className="w-full h-full object-cover"
                        />
                    </div>

                    <div>
                        <div className="inline-block px-4 py-2 bg-[#29abe2] bg-opacity-10 rounded-full mb-6">
                            <span className="text-[#29abe2] font-semibold">Company Vision</span>
                        </div>
                        <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
                            Our Next Level Logistics Around the World
                        </h2>
                        <p className="text-lg text-gray-600 mb-12">
                            With over four decades of experience providing solutions to large-scale enterprises 
                            throughout the globe, we offer end-to-end logistics tailored for specific markets.
                        </p>

                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                            <div className="text-center p-6 bg-gray-50 rounded-lg">
                                <div className="text-4xl font-bold text-[#29abe2] mb-2">92%</div>
                                <div className="text-gray-700">Successful Delivery</div>
                            </div>
                            <div className="text-center p-6 bg-gray-50 rounded-lg">
                                <div className="text-4xl font-bold text-[#29abe2] mb-2">95%</div>
                                <div className="text-gray-700">Happy Customers</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Partners Carousel */}
                <div className="mt-20">
                    <div className="text-center mb-12">
                        <div className="inline-block px-4 py-2 bg-[#29abe2] bg-opacity-10 rounded-full mb-4">
                            <span className="text-[#29abe2] font-semibold">Our Partners</span>
                        </div>
                        <h2 className="text-3xl font-bold text-gray-900">
                            Trusted By Industry Leaders
                        </h2>
                    </div>
                    
                    <div className="px-12">
                        <Slider {...partnerSliderSettings} className="partner-carousel">
                            {partners.map((partner, index) => (
                                <div key={index} className="px-4">
                                    <div className="relative h-40 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300">
                                        <img
                                            src={`/images/partners/partner${partner.id}.jpg`}
                                            alt={partner.name}
                                            className="w-full h-full object-contain p-4"
                                        />
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CompanyStats; 